/**
 * Back in Stock – Pitstopstore
 * Popup-E-Mail-Erfassung + Einreichung via Shopify Contact Form
 */
;(function () {
  'use strict';

  // ─── CSS-Injection ─────────────────────────────────────────────────────────
  (function injectStyles() {
    if (document.getElementById('bis-styles')) return;
    var s = document.createElement('style');
    s.id = 'bis-styles';
    s.textContent = [
      /* Overlay */
      '.bis-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;align-items:center;justify-content:center;padding:16px;}',
      '.bis-overlay.is-open{display:flex;}',
      /* Modal */
      '.bis-modal{background:#fff;border-radius:8px;width:100%;max-width:580px;max-height:90vh;overflow-y:auto;padding:28px 32px;position:relative;box-shadow:0 20px 60px rgba(0,0,0,.2);}',
      /* Close-Button */
      '.bis-close{position:absolute;top:14px;right:14px;background:none;border:none;cursor:pointer;color:#677279;padding:4px;line-height:1;border-radius:4px;}',
      '.bis-close:hover{color:#1a1a1a;}',
      /* Titel */
      '.bis-modal__title{font-size:17px;font-weight:700;margin:0 40px 0 0;line-height:1.3;color:#1a1a1a;}',
      '.bis-modal__divider{border:none;border-top:1px solid #e8e8e8;margin:16px 0;}',
      '.bis-modal__subtitle{font-size:14px;color:#677279;margin:0 0 20px;line-height:1.55;}',
      /* Produktzeile */
      '.bis-modal__product-row{display:flex;gap:20px;align-items:flex-start;}',
      '.bis-modal__thumb{flex-shrink:0;width:110px;height:110px;}',
      '.bis-modal__thumb img{width:100%;height:100%;object-fit:contain;border-radius:4px;}',
      '.bis-modal__details{flex:1;min-width:0;}',
      '.bis-modal__product-title{font-size:15px;font-weight:600;margin:0 0 4px;line-height:1.35;color:#1a1a1a;}',
      '.bis-modal__variant{font-size:13px;color:#677279;margin:0 0 16px;}',
      /* Formular */
      '.bis-form__label{display:block;font-size:13px;color:#677279;margin-bottom:6px;}',
      '.bis-form__input{width:100%;padding:10px 14px;border:1px solid #d1d5db;border-radius:4px;font-size:14px;margin-bottom:12px;outline:none;transition:border-color .2s;box-sizing:border-box;font-family:inherit;}',
      '.bis-form__input:focus{border-color:#6b7280;}',
      '.bis-form__submit{width:100%;padding:14px 20px;border:none;font-size:15px;font-weight:600;cursor:pointer;transition:opacity .2s;line-height:1.2;font-family:inherit;display:block;}',
      '.bis-form__submit:hover{opacity:.85;}',
      '.bis-form__submit:disabled{opacity:.5;cursor:not-allowed;}',
      /* Erfolgsmeldung */
      '.bis-success{text-align:center;padding:12px 0 4px;}',
      '.bis-success__text{font-size:15px;color:#1a1a1a;margin:0;line-height:1.5;}',
      /* Trigger-Button */
      '.bis-trigger{transition:opacity .2s;}',
      '.bis-trigger:hover{opacity:.85;}',
      /* Mobile */
      '@media(max-width:560px){',
        '.bis-modal{padding:20px 16px;}',
        '.bis-modal__product-row{flex-direction:column;}',
        '.bis-modal__thumb{width:80px;height:80px;}',
      '}'
    ].join('');
    document.head.appendChild(s);
  })();

  // ─── Modal-Hilfsfunktionen ─────────────────────────────────────────────────
  function getOrCreateModal(targetId) {
    var existing = document.getElementById(targetId);
    if (existing) return existing;

    var tpl = document.getElementById(targetId + '-tpl');
    if (!tpl) return null;

    var clone = tpl.content.cloneNode(true);
    document.body.appendChild(clone);

    var modal = document.getElementById(targetId);
    if (modal) bindModal(modal);
    return modal;
  }

  function openModal(targetId) {
    var modal = getOrCreateModal(targetId);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var input = modal.querySelector('.bis-form__input');
    if (input) setTimeout(function () { input.focus(); }, 60);
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ─── Klaviyo API ───────────────────────────────────────────────────────────
  var KLAVIYO_KEY = 'VFjNYk';

  function submitBIS(modal) {
    var input = modal.querySelector('.bis-form__input');
    var btn   = modal.querySelector('[data-bis-submit]');
    if (!input || !btn) return;

    if (!input.value.trim() || !input.checkValidity()) {
      input.reportValidity();
      return;
    }

    btn.disabled = true;

    var email      = input.value.trim();
    var variantId  = btn.dataset.variantId || '';
    var product    = btn.dataset.product   || '';
    var variant    = btn.dataset.variant   || '';
    var productUrl = btn.dataset.url       || '';
    var productImg = btn.dataset.image     || '';

    var apiBase = 'https://a.klaviyo.com/client/';
    var headers = { 'Content-Type': 'application/json', 'revision': '2024-02-15' };

    // 1) Native Klaviyo Back-in-Stock Subscription
    //    → Klaviyo benachrichtigt automatisch wenn Artikel wieder verfügbar
    fetch(apiBase + 'back-in-stock-subscriptions/?company_id=' + KLAVIYO_KEY, {
      method: 'POST', headers: headers,
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).catch(function () {});

    // 2) Custom Event mit Produktdaten für Bestätigungs-E-Mail im Flow
    fetch(apiBase + 'events/?company_id=' + KLAVIYO_KEY, {
      method: 'POST', headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Back In Stock Request' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: {
              ProductName:  product,
              VariantName:  variant,
              VariantId:    variantId,
              ProductURL:   productUrl,
              ProductImage: productImg ? 'https:' + productImg : ''
            }
          }
        }
      })
    })
    .then(function ()  { showSuccess(modal); })
    .catch(function () { showSuccess(modal); });
  }

  function showSuccess(modal) {
    var formArea = modal.querySelector('.bis-form-area');
    var success  = modal.querySelector('.bis-success');
    if (formArea) formArea.style.display = 'none';
    if (success)  success.style.display  = '';
  }

  // ─── Modal-Events binden ───────────────────────────────────────────────────
  function bindModal(modal) {
    modal.querySelectorAll('[data-bis-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });

    var submitBtn = modal.querySelector('[data-bis-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () { submitBIS(modal); });
    }

    var emailInput = modal.querySelector('.bis-form__input');
    if (emailInput) {
      emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submitBIS(modal); }
      });
    }
  }

  // ─── Init (Event-Delegation – funktioniert auch nach Varianten-Rerender) ───
  function init() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-bis-target]');
      if (trigger) openModal(trigger.dataset.bisTarget);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.bis-overlay.is-open').forEach(function (m) {
          closeModal(m);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
